// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","42530": "81999d02ec3f","44299": "f03ba1936f33","66863": "c939bdd77392","70127": "7a1cbee46a14","7658": "3505e50fd8f4","95756": "1d198fe02b74",}[chunkId] + ".css"
}